import { useEffect, useState } from 'react'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations';


export default function CommanLabAvailability() {
    const AfflLabAvailValidation = Yup.object({
        data: Yup.array().of(Yup.object().shape({
            labType: Yup.string().required(ERROR_MSG).nullable(),
            equipmentProvided: Yup.string().when('labType', {
                is: 'Lab Required for this Course and Lab Available in College',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),
            noOfLabsProvided: Yup.string().when('labType', {
                is: 'Lab Required for this Course and Lab Available in College',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            })

        })),
    })
    const AfflLabAvaialFormik = useFormik({
        initialValues: {
            data: [
                {
                    labType: "",
                    noOfLabsProvided: "",
                    equipmentProvided: "",
                    courseId: "",
                    subId: ""
                }
            ],
        },
        validationSchema: AfflLabAvailValidation,
        onSubmit: (values) => {
            values.data.forEach(item => {
                item.courseId = item.courseId ? parseInt(item.courseId, 10) : '';
                item.subId = item.subId ? parseInt(item.subId, 10) : '';
                item.noOfLabsProvided = item.noOfLabsProvided ? parseInt(item.noOfLabsProvided, 10) : '';
            });

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveLabAvailibityDetails`;
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            getLabAvailData();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })


    const [coursecatDta, setcoursecatDta] = useState([]);
    function GetCorseCatList() {
        let url = config.url.API_URL + `courseCategories`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcoursecatDta(res?.data?.courseCategories);

            }
            else {
                setcoursecatDta([]);
            }
        })
    }
    const [LabAvailData, setLabAvailData] = useState([]);
    function getLabAvailData() {
        let url = config?.url?.API_URL + "getLabAvailibityDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setLabAvailData(res?.data?.getLabAvailibityDetails);

            }
            else {
                setLabAvailData([]);

            }

        })
    }

    useEffect(() => {
        GetCorseCatList();
        getLabAvailData();
    }, [])

    useEffect(() => {

        if (coursecatDta) {
            const dataitialValues = coursecatDta?.map(course => ({
                labType: "",
                noOfLabsProvided: "",
                equipmentProvided: "",
                courseId: course?.course_cat_id,
                subId: course?.course_id
            }));
            AfflLabAvaialFormik.setValues({ ...AfflLabAvaialFormik?.values, data: dataitialValues });
        }
    }, [coursecatDta]);
    return (
        <>
            <FormikProvider value={AfflLabAvaialFormik}>
                <Form onChange={AfflLabAvaialFormik?.handleChange} onSubmit={AfflLabAvaialFormik?.handleSubmit} className='affl-form'>
                    {!LabAvailData || LabAvailData.length === 0 ? (<>
                        {/* {LabAvailData.some(item => item.no_of_labs_provided !== null) ? (<> */}
                        <div className="table-responsive">

                            <table className="table table-condensed table-bordered  table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Single Major Courses with Specialization	</th>
                                        <th>Lab Details	</th>
                                        <th>Number of Labs Provided for this Subject</th>
                                        <th>Is Equipment provided as per the Norms of the University
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coursecatDta && coursecatDta?.map((course, index) => (<>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: "left" }}>{course?.course_cat_name}
                                                {/* <Field type="hidden" name={`data[${index}].courseId`} />
                                                <Field type="hidden" name={`data[${index}].subId`} /> */}

                                            </td>
                                            <td>
                                                <Field as="select" className="form-control" name={`data[${index}].labType`}
                                                    onChange={e => {
                                                        AfflLabAvaialFormik?.setFieldValue(`data[${index}].noOfLabsProvided`, '');
                                                        AfflLabAvaialFormik?.setFieldValue(`data[${index}].equipmentProvided`, '');
                                                    }}>
                                                    <option value=''>---selct---</option>
                                                    <option value="Lab Required for this Course and Lab Available in College">Lab Required for this Course and Lab Available in College</option>
                                                    <option value="Lab Required for this Course and Lab Not Available in college">Lab Required for this Course and Lab Not Available in college</option>
                                                    <option value="Lab Not Required for this Course">Lab Not Required for this Course</option>

                                                </Field>
                                                <ErrorMessage name={`data[${index}].labType`} component="div" className="text-error" />
                                            </td>
                                            {AfflLabAvaialFormik?.values?.data[index]?.labType === "Lab Required for this Course and Lab Available in College" ? (<>
                                                <td>
                                                    <Field type="text" className="form-control" name={`data[${index}].noOfLabsProvided`} onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        maxLength="4" onPaste={(e) => handlePaste(e)} />

                                                    <ErrorMessage name={`data[${index}].noOfLabsProvided`} component="div" className="text-error" />
                                                </td>
                                                <td>   <Field as="select" className="form-control" name={`data[${index}].equipmentProvided`} >
                                                    <option value=''>---select---</option>
                                                    <option values="true">Yes</option>
                                                    <option values="false">No</option>

                                                </Field>
                                                    <ErrorMessage name={`data[${index}].equipmentProvided`} component="div" className="text-error" />
                                                </td>
                                            </>) : <td colSpan={2}></td>}

                                        </tr>

                                    </>))}

                                </tbody>
                            </table>

                        </div>

                        <div className="button-cend pt-1 mb-3">

                            <button type="submit" className="btn btn-success mt-2 float-end mb-2">
                                Submit
                            </button>
                        </div>

                    </>) : (<>
                        <div className="table-responsive">

                            <table className="table table-condensed table-bordered table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Single Major Courses with Specialization	</th>
                                        <th>Lab Details	</th>
                                        <th>Number of Labs Provided for this Subject</th>
                                        <th>Is Equipment provided as per the Norms of the University
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {LabAvailData !== undefined && LabAvailData !== null && LabAvailData !== '' && LabAvailData?.map((data, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td className='text-left'>{data?.course_cat_name}</td>
                                            <td className='text-left'>{data?.lab_type}</td>
                                            <td>{data?.no_of_labs_provided}</td>
                                            <td>{data?.equipment_provided}</td>


                                        </tr>))}
                                </tbody>
                            </table>
                        </div>


                    </>)}
                    <br />
                </Form>
            </FormikProvider>
        </>
    )
}
